export default __webpack_public_path__ + "static/media/why_img_4.3553ef93.png";